/**
 * Настройки ресурса «Собственный источник» в реестре Platform — схема вида `Platform.Infrastructure/Connectors/own.settings.schema.json`
 * (`urn:kalmykov:own:settings:v2`): только версия схемы. Каталог — сам ресурс (один вид `own` = номенклатура, цены, РМК и чеки), настройки продажи
 * (вид цены по умолчанию) хранит служба Resource.Own (`GET/PUT api/own/v1/resources/{rid}/sale-settings`), а не реестр. Секрета у вида
 * нет: оборудование стоит у кассира, а не в сети.
 */
export const OWN_KIND = 'own'
export const OWN_TITLE = 'Собственный источник'
export const OWN_SCHEMA_VERSION = 'own.settings.v2'

/** Права вида `own` словами; список прав и их принадлежность модулям — в манифесте вида с сервера, здесь только слова. */
export const OWN_CAPABILITY_LABELS: Readonly<Record<string, string>> = {
  'session.open': 'Работать с источником',
  'catalog.read': 'Смотреть товары своей базы',
  'catalog.write': 'Менять товары своей базы',
  'prices.read': 'Смотреть цены своей базы',
  'prices.write': 'Менять цены своей базы',
  'receipts.read': 'Смотреть собственные чеки',
  'receipts.ingest': 'Принимать чеки от оборудования',
  'receipts.devices.manage': 'Вести устройства и ключи собственной кассы',
  'receipts.cashiers.manage': 'Вести кассиров собственной кассы',
}

export const OWN_CAPABILITY_HINTS: Readonly<Record<string, string>> = {
  'session.open': 'Открывает кассиру плитку источника, окно продажи, поиск товаров и виды цен. Просмотр собственных чеков разрешается отдельно.',
  'catalog.read': 'Открывает вкладку своей базы в «Номенклатуре»: товары, группы, карточку товара.',
  'catalog.write': 'Разрешает заводить, менять, убирать в архив и возвращать товары и группы своей базы.',
  'prices.read': 'Открывает вкладку своей базы в «Ценах»: виды цен, цены товара на дату и их историю.',
  'prices.write': 'Разрешает заводить и менять виды цен и записывать или удалять цены товаров своей базы.',
  'receipts.read': 'Открывает журнал собственных чеков и смен этого источника. Глобальная аналитика кассиров разрешается отдельно.',
  'receipts.ingest': 'Разрешает принимать факты чеков и смен от доверенной службы оборудования. Само по себе не разрешает кассиру выполнять оплату.',
  'receipts.devices.manage': 'Разрешает вести реестр устройств собственной кассы и их ключи, а также разбирать записи ведомости приёма чеков.',
  'receipts.cashiers.manage': 'Разрешает вести справочник кассиров собственной кассы: заводить, менять и убирать кассиров.',
}

/**
 * Модули вида `own` словами (ADR-22): каталог и цены — служба Resource.Own, чеки и кассиры — Resource.Receipts. Какие права
 * и службы входят в модуль, говорит манифест вида с сервера; здесь только название и «что даёт».
 */
export const OWN_MODULE_TITLES: Readonly<Record<string, string>> = {
  catalog: 'Каталог и цены',
  receipts: 'Чеки и кассиры',
}

export const OWN_MODULE_HINTS: Readonly<Record<string, string>> = {
  catalog: 'Товары и цены собственной базы, продажа через кассу.',
  receipts: 'Журнал чеков и смен, оборудование и кассиры собственной кассы.',
}

export interface OwnSettingsIssue {
  field: string
  message: string
}

export function emptyOwnSettings(): Record<string, unknown> {
  return { schemaVersion: OWN_SCHEMA_VERSION }
}

/** Проверять в настройках реестра нечего: вид цены по умолчанию и прочее живёт в службе ресурса. */
export function validateOwnSettings(_settings: Readonly<Record<string, unknown>>): OwnSettingsIssue[] {
  return []
}
